module.exports = __webpack_public_path__ + "img/transparent-nav-right-mazda.0e47b574.png";